
define('text!templates/modules/member/supervisors/supervisors.html',[],function () { return '<div class="coachs-section">\n    <div class="next-coach">{{#t}}Next coach{{/t}} ></div>\n    <div class="coachs"></div>\n</div>\n';});

